import { Route } from '@angular/router';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';
import { NoAuthenticatedGuard } from './core/authentication/guards/no-authenticated.guard';
import { AuthenticatedGuard } from './core/authentication/guards/authenticated.guard';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    {
        path: 'public',
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: '',
                loadChildren: () =>
                    import('app/modules/public/public.module').then(
                        (m) => m.PublicModule
                    ),
            },
        ],
    },

    // Redirect empty path to '/portal'
    { path: '', pathMatch: 'full', redirectTo: 'portal' },

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'portal' },

    // Specific routes that should be checked before catchall
    // These routes have explicit paths to avoid being caught by the catchall
    {
        path: 'sign-in',
        canMatch: [NoAuthenticatedGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: '',
                loadChildren: () =>
                    import('app/modules/auth/sign-in/sign-in.module').then(
                        (m) => m.AuthSignInModule
                    ),
            },
        ],
    },
    {
        path: 'sign-out',
        canMatch: [AuthenticatedGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: '',
                loadChildren: () =>
                    import('app/modules/auth/sign-out/sign-out.module').then(
                        (m) => m.AuthSignOutModule
                    ),
            },
        ],
    },
    {
        path: 'role-selection',
        canMatch: [AuthenticatedGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: '',
                loadChildren: () =>
                    import(
                        'app/modules/auth/role-selection/role-selection.module'
                    ).then((m) => m.RoleSelectionModule),
            },
        ],
    },
    {
        path: 'home',
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: '',
                loadChildren: () =>
                    import('app/modules/landing/home/home.module').then(
                        (m) => m.LandingHomeModule
                    ),
            },
        ],
    },
    {
        path: 'portal',
        canMatch: [AuthenticatedGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: '',
                loadChildren: () =>
                    import('app/modules/portal/portal.module').then(
                        (m) => m.PortalModule
                    ),
            },
        ],
    },
    /*
    {
        path: ':mark1/:mark2',
        pathMatch: 'full',
        redirectTo: '/public/validation/proposal/:mark1/:mark2',
    },
    */
    // NotFound route (catchall) - Must be at the end to catch all unmatched routes
    {
        path: '**',
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: '',
                loadChildren: () =>
                    import('app/modules/not-found/not-found.module').then(
                        (m) => m.NotFoundModule
                    ),
            },
        ],
    },
];
